import {
	mapActions,
	mapGetters
} from 'vuex';

import toastr from '@/support/toastr';

export default {
	name: 'message-users',
	props: {
		users: {
			type: Array
		}
	},
	data: () => ({
		participantsList: [],
		participants: {
			responsibles: {
				title: 'Pais/Responsáveis',
				list: []
			},
			schoolMembers: {
				title: 'Membros da escola',
				list: []
			}
		},
		newParticipant: ''
	}),
	computed: {
		...mapGetters({
			user: 'getLoggedUser',
			messageGroup: 'messageGroup',
			responsibles: 'getInboxResponsibles',
			schoolMembers: 'getInboxSchoolMembers'
		})
	},
	methods: {
		...mapActions([
			'getMessageRecipient',
			'putMessageRecipients',
			'getMessageRecipientIsResponsible',
			'setMessageRecipientResponsible',
			'setMessageRecipientSchoolMembers',
			'getMessageGroup'
		]),
		retrieveMessageRecipients() {

			return this.getMessageRecipient({
				userId: this.user.id,
				studentId: this.messageGroup.student.studentId,
			}).then((response) => {

				this.getMessageRecipientIsResponsible(true).then((response) => {

					this.setMessageRecipientResponsible(response);
					this.participants.responsibles.list = response;

				});

				this.getMessageRecipientIsResponsible(false).then((response) => {

					this.setMessageRecipientSchoolMembers(response);
					this.participants.schoolMembers.list = response;

				});

				return response;

			});

		},
		onSubmit() {

			this.$validator.validateAll().then((valid) => {

				if (valid) {

					return this.putMessageRecipients({
						messageGroup: this.messageGroup.messageGroup,
						userId: this.user.id,
						newUserId: this.newParticipant
					}).then((response) => {

						this.getMessageGroup(this.$router.history.current.params.id);

						toastr.success('Participante adicionado com sucesso!');

						return response;

					});

				} else {
					toastr.warning('Participante não informado');
				}

			});

		}
	},
	mounted() {

		this.$store.watch((state) => state.Inbox.messageGroup, () => {
			this.retrieveMessageRecipients();
		});

	}
};



// WEBPACK FOOTER //
// ./sources/domains/inbox/message-users/index.js